import clsx from 'clsx';
import { useId } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../button/Button';
import { CloseIcon } from '../icons';
import { IconButton } from '../icon-button/IconButton';
import { useOverlayEffects } from '../../hooks';
import styles from './ConfirmDialog.module.css';

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  onSave,
  title,
  body,
  confirmLabel,
  cancelLabel,
  saveLabel,
  confirmVariant,
}) {
  const titleId = useId();
  const descId = useId();
  useOverlayEffects({ open, onClose });

  if (!open) return null;

  return createPortal(
    <div className={clsx(styles.overlay)} role="presentation" onClick={onClose}>
      <div
        className={clsx(styles.panel)}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descId}
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton ariaLabel="Close" className={clsx(styles.close)} onClick={onClose} size="sm">
          <CloseIcon className={clsx(styles.closeIcon)} aria-hidden />
        </IconButton>

        <div className={clsx(styles.textBlock)}>
          <h2 id={titleId} className={clsx(styles.title)}>
            {title}
          </h2>
          <p id={descId} className={clsx(styles.body)}>
            {body}
          </p>
        </div>

        <div className={clsx(styles.actions)}>
          {onSave ? (
            <>
              <Button size="sm" variant={confirmVariant} type="button" onClick={onConfirm}>
                {confirmLabel}
              </Button>
              <Button size="sm" variant="primary" type="button" onClick={onSave}>
                {saveLabel}
              </Button>
            </>
          ) : (
            <>
              <Button size="sm" variant="outline" type="button" onClick={onClose}>
                {cancelLabel}
              </Button>
              <Button size="sm" variant={confirmVariant} type="button" onClick={onConfirm}>
                {confirmLabel}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}
